<script setup lang="ts">
  import type { DownloadableFile } from '@/types/File'
  import FileDownload from '@/components/common/FileDownload.vue'

  const file = withDefaults(defineProps<DownloadableFile>(), {
    bytes: 0,
    intro: '',
    fieldIdentifier: 'file',
  })
</script>

<template>
  <FileDownload
    :file="file"
    class="cms-a"
  >
    {{ file.name }}
  </FileDownload>
</template>
